import React from 'react';
import { useIntl } from 'react-intl';
import DataBox from '../../Dashboard/DataBox';
import AppointmentsBranchCounters from './AppointmentsBranchCounters';
import AppointmentsOutcomeCounters from './AppointmentsOutcomeCounters';

const CountersWrapper = function CountersWrapper({
  branchCounters,
  outcomeCounters,
}) {
  const intl = useIntl();
  return (
    <>
      {branchCounters && (
        <DataBox
          title={intl.messages.COMPLETED_APPOINTMENTS_BY_BRANCH}
          widget={
            <AppointmentsBranchCounters branchCounters={branchCounters} />
          }
        />
      )}

      {outcomeCounters && (
        <AppointmentsOutcomeCounters outcomeCounters={outcomeCounters} />
      )}
    </>
  );
};
export default CountersWrapper;
